import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Tag,
  message,
  Descriptions,
  Button,
  Tabs,
  Spin,
  Typography,
  Avatar,
} from "antd";
import { useParams, Link } from "react-router-dom";
import {
  UserOutlined,
  CarOutlined,
  FileTextOutlined,
  ArrowRightOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import axios from "axios";

const { TabPane } = Tabs;
const { Title } = Typography;

const AgreementDetail = () => {
  const { id } = useParams();
  const [agreementData, setAgreementData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAgreementDetails();
  }, [id]);

  const fetchAgreementDetails = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`http://93.127.203.113:5005/agreements/${id}`);
      setAgreementData(response.data);
    } catch (error) {
      message.error("Failed to fetch agreement details.");
    } finally {
      setLoading(false);
    }
  };

  const renderImage = (src, alt) => {
    if (!src) return <Avatar shape="square" icon={<UserOutlined />} style={{ width: "100%", height: "300px", borderRadius: "10px", backgroundColor: "#f0f2f5" }} />;

    const imageUrl = `http://93.127.203.113:5005${src.replace(/\\/g, "/")}`;
    return (
      <img
        src={imageUrl}
        alt={alt}
        style={{
          width: "100%",
          height: "300px",
          objectFit: "cover",
          borderRadius: "10px",
        }}
        onError={(e) => { e.target.src = "https://via.placeholder.com/300"; }} // Fallback image
      />
    );
  };

  

  return (
    <div style={{ padding: "20px" }}>
      {loading ? (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          <Spin size="large" />
        </div>
      ) : (
        <Card
          style={{
            borderRadius: "10px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            borderTop: "5px solid #0c8c49",
          }}
        >
          <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
            Agreement Details
          </Title>
          <Tabs defaultActiveKey="1" type="card">
            {/* Agreement Overview */}
            <TabPane
              tab={
                <span>
                  <ArrowRightOutlined /> Agreement Overview
                </span>
              }
              key="1"
            >
              <Row gutter={[24, 24]}>
                <Col span={24} md={12}>
                  <Card
                    title="Agreement Information"
                    bordered={false}
                    extra={
                      agreementData?.agreementId && (
                        <Link to={`/agreementDetails/${agreementData.agreementId}`}>
                          <Button type="link" style={{ color: "#0c8c49" }}>
                            View Agreement Details
                          </Button>
                        </Link>
                      )
                    }
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <Descriptions bordered column={1}>
                      <Descriptions.Item label="Owner Name">
                        {agreementData?.owner?.name || "N/A"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Vehicle">
                        {agreementData?.vehicle?.plateNumber || "N/A"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Price Per Day">
                        <Tag color="#0c8c49">${agreementData?.pricePerDay}</Tag>
                      </Descriptions.Item>
                      <Descriptions.Item label="Start Date">
                        {agreementData?.startDate
                          ? new Date(agreementData.startDate).toLocaleDateString()
                          : "N/A"}
                      </Descriptions.Item>
                      <Descriptions.Item label="End Date">
                        {agreementData?.endDate
                          ? new Date(agreementData.endDate).toLocaleDateString()
                          : "N/A"}
                      </Descriptions.Item>
                    </Descriptions>
                  </Card>
                </Col>
                <Col span={24} md={12}>
                  <Card title="Agreement Document" bordered={false}
                    extra={
                      agreementData?.agreementDocument && (
                        <a href={`http://93.127.203.113:5005${agreementData.agreementDocument.replace(/\\/g, "/")}`} target="_blank" rel="noopener noreferrer">
                          <Button type="link" style={{ color: "#0c8c49" }}>View Document</Button>
                        </a>
                      )
                    }
                    style={{ borderRadius: "10px", boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)" }}
                  >
                    {renderImage(agreementData?.agreementDocument, "Agreement Document")}
                  </Card>
                </Col>
              </Row>
            </TabPane>

            {/* Owner Information */}
            <TabPane
              tab={
                <span>
                  <UserOutlined /> Owner Details
                </span>
              }
              key="2"
            >
              <Card
                title="Owner Information"
                bordered={false}
                extra={
                  agreementData?.owner && (
                    <Link to={`/ownerDetails/${agreementData.owner.id}`}>
                      <Button type="link" style={{ color: "#0c8c49" }}>
                        View Owner Details
                      </Button>
                    </Link>
                  )
                }
                style={{
                  borderRadius: "10px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Descriptions bordered column={1}>
                  <Descriptions.Item label="Owner Name">
                    {agreementData?.owner?.name || "N/A"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Contact">
                    {agreementData?.owner?.contact || "N/A"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Email">
                    {agreementData?.owner?.email || "N/A"}
                  </Descriptions.Item>
                </Descriptions>
              </Card>
            </TabPane>

            {/* Vehicle Information */}
            <TabPane
              tab={
                <span>
                  <CarOutlined /> Vehicle Details
                </span>
              }
              key="3"
            >
              <Card
                title="Vehicle Information"
                bordered={false}
                extra={
                  agreementData?.vehicle && (
                    <Link to={`/vehicleDetails/${agreementData.vehicle.id}`}>
                      <Button type="link" style={{ color: "#0c8c49" }}>
                        View Vehicle Details
                      </Button>
                    </Link>
                  )
                }
                style={{
                  borderRadius: "10px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Descriptions bordered column={1}>
                  <Descriptions.Item label="Plate Number">
                    {agreementData?.vehicle?.plateNumber || "N/A"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Model">
                    {agreementData?.vehicle?.model || "N/A"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Color">
                    {agreementData?.vehicle?.color || "N/A"}
                  </Descriptions.Item>
                </Descriptions>
              </Card>
            </TabPane>

            {/* Vehicle Inspection */}
            <TabPane
              tab={
                <span>
                  <CheckCircleOutlined /> Vehicle Inspection
                </span>
              }
              key="4"
            >
              <Card
                title="Inspection Information"
                bordered={false}
                extra={
                  agreementData?.inspection && (
                    <Link
                      to={`/inspectionDetails/${agreementData.inspection.id}`}
                    >
                      <Button type="link" style={{ color: "#0c8c49" }}>
                        View Inspection Details
                      </Button>
                    </Link>
                  )
                }
                style={{
                  borderRadius: "10px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Descriptions bordered column={1}>
                  <Descriptions.Item label="Inspection Date">
                    {agreementData?.inspection?.inspectionDate
                      ? new Date(
                          agreementData.inspection.inspectionDate
                        ).toLocaleDateString()
                      : "N/A"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Fuel Status">
                    {agreementData?.inspection?.fuelStatus || "N/A"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Remarks">
                    {agreementData?.inspection?.remarks || "N/A"}
                  </Descriptions.Item>
                </Descriptions>
              </Card>
            </TabPane>
          </Tabs>
        </Card>
      )}
    </div>
  );
};

export default AgreementDetail;
